module.exports = __webpack_public_path__ + "img/icon-refresh.7a65c427.svg";